<template>
    <div :class="`page ${ accessToken ? 'page--logged-in' : '' }`">
        <menu-bar v-if="accessToken" />

        <div
            :class="{
                'page__container': accessToken,
                'page__container page__container--estate': route.name === 'estate-by-uuid-en' || route.name === 'estate-by-uuid-sv'
            }"
        >
            <snackbar :data="snackbarData" />
            <router-view></router-view>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, computed, watchEffect, onMounted } from 'vue'
    import { useStore }                   from 'vuex'
    import { useRoute }                   from 'vue-router'
    import { getCache, switchHeaderType } from '@/helpers'
    import globalStoreGetters             from '@constans/store/global/globalStoreGetters'
    import userStoreMutations             from '@constans/store/user/userStoreMutations'
    import authStoreMutations             from '@constans/store/auth/authStoreMutations'
    import authStoreGetters               from '@constans/store/auth/authStoreGetters'
    import estateStoreMutations           from '@constans/store/estate/estateStoreMutations'
    import menuBar                        from '@components/menuBar.vue'
    import snackbar                       from '@components/snackbar.vue'

    export default defineComponent({
        components: {
            menuBar,
            snackbar
        },
        setup() {
            const cache = getCache()
            const route = useRoute()
            const store = useStore()
            const accessToken = computed(() => store.getters[`auth/${ authStoreGetters.GET_ACCESS_TOKEN }`])
            const snackbarData = computed(() => store.getters[`global/${ globalStoreGetters.GET_SNACKBAR }`])

            onMounted(() => {
                if (cache && 'access_token' in cache) {
                    store.commit(`user/${ userStoreMutations.SET_USER }`, cache.user)
                    store.commit(`auth/${ authStoreMutations.SET_AUTH }`, {
                        access_token: cache.access_token,
                        expires_in: cache.expires_in,
                        token_type: cache.token_type
                    })

                    if ('estateList' in cache) {
                        store.commit(`estate/${ estateStoreMutations.SET_ESTATE_LIST }`, cache.estateList)
                    }
                }
            })

            watchEffect(() => switchHeaderType(accessToken.value?.length > 0))

            return {
                route,
                accessToken,
                snackbarData
            }
        }
    })
</script>
